import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import MiPedido from '../MiPedido/MiPedido';

export default function Cart() {

    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);

    const [isFocused, setIsFocused] = useState(false);

    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');

    const [tienda, setTienda] = useState([]);

    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);

    const [totalPrice, setTotalPrice] = useState(0);

    const [deliveryOption, setDeliveryOption] = useState('delivery');

    const [metodos, setMetodos] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [pagoRecibir, setPagoRecibir] = useState('');

    const [estado, setEstado] = useState(null);

    const [address, setAddress] = useState('');

    const [tipoEntrega, setTipoEntrega] = useState('mesa'); // 'mesa' | 'delivery'

    // ---------------- MESAS ----------------
    const [mesas, setMesas] = useState([]);
    const [idMesa, setIdMesa] = useState('');
    const [buscandoUbicacion, setBuscandoUbicacion] = useState(false);

    const handleSelectChange = (event) => {
        setIdMesa(event.target.value);
    };

    const obtenerUbicacion = () => {

        setBuscandoUbicacion(true);

        const options = {
            enableHighAccuracy: false,
            timeout: 30000,
            maximumAge: 600000
        };

        const success = (position) => {

            const lat = position.coords.latitude;
            const lng = position.coords.longitude;

            const urlMaps = `https://maps.google.com/?q=${lat},${lng}`;

            setDireccion(urlMaps);
            setBuscandoUbicacion(false);

            Swal.fire('OK', 'Ubicación obtenida', 'success');
        };

        const error = (err) => {

            setBuscandoUbicacion(false);

            Swal.fire(
                'Error GPS',
                `Código: ${err.code} - ${err.message}`,
                'error'
            );
        };

        // 🔥 IMPORTANTE: delay para Safari iOS
        setTimeout(() => {
            navigator.geolocation.getCurrentPosition(success, error, options);
        }, 300);
    };

    const cargarMesas = () => {
        fetch(`${baseURL}/mesaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setMesas(data.mesas || []);
            })
            .catch(error => console.error('Error al cargar mesas:', error));
    };
    // ----------------------------------------

    const createdAt = new Date().toLocaleString('sv-SE', {
        timeZone: 'America/Lima',
    }).replace(',', '');

    useEffect(() => {
        cargarTienda();
        cargarMesas();
    }, []);

    useEffect(() => {

        let totalPriceCalc = 0;

        cartItems.forEach((item) => {

            const base = Number(item.precio || 0);

            const extras = Number(item.extras || 0);

            const final = base + extras;

            const subtotal = final * Number(item.cantidad || 1);

            totalPriceCalc += subtotal;
        });

        setTotalPrice(totalPriceCalc);

    }, [cartItems]);

    useEffect(() => {

        const fetchEstado = async () => {

            try {

                const response = await fetch(`${baseURL}/estado.php?`);
                const data = await response.json();

                if (data.error) {
                    console.error(data.error);
                } else {
                    setEstado(data.estado);
                }

            } catch (error) {
                console.error("Error al obtener el estado:", error);
            }
        };

        fetchEstado();

    }, []);

    const cargarTienda = () => {

        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse() || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    useEffect(() => {

        cargarMetodos();
        cargarProductos();

    }, [isFocused]);

    useEffect(() => {

        const fetchCartItems = async () => {

            const cart = JSON.parse(localStorage.getItem('cart')) || [];

            const promises = cart.map(async (cartItem) => {

                const producto = productos.find(
                    producto => producto.idProducto === cartItem.idProducto
                );

                const precioBase = Number(producto?.precio || 0);
                const extras = Number(cartItem?.extras || 0);

                return {
                    ...producto,

                    cantidad: Number(cartItem.cantidad || 1),
                    items: cartItem.items || [],

                    extras,

                    // 🔥 SIEMPRE número real
                    precioFinal: precioBase + extras,
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();

    }, [productos, isFocused]);

    const cargarMetodos = () => {

        fetch(`${baseURL}/metodoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {

                const metodosActivos =
                    (data.metodos || [])
                        ?.filter(metodo => metodo.estado === 'Activo');

                setMetodos(metodosActivos);

            })
            .catch(error => console.error('Error al cargar datos bancarios:', error));
    };

    const cargarProductos = () => {

        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
        cargarMesas();
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => {
        setModalIsOpen2(true);
        cargarMesas();
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const removeFromCart = (id) => {

        const updatedCart = cartItems.filter(
            item => item.idProducto !== id
        );

        setCartItems(updatedCart);

        localStorage.setItem(
            'cart',
            JSON.stringify(updatedCart)
        );
    };

    const clearCart = () => {

        setCartItems([]);

        localStorage.removeItem('cart');
    };

    const [codigos, setCodigos] = useState([]);

    useEffect(() => {
        cargarCodigos();
    }, []);

    const cargarCodigos = () => {

        fetch(`${baseURL}/codigosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    const formatItemsForWhatsapp = (items = []) => {

        if (!Array.isArray(items) || items.length === 0) {
            return '';
        }

        return items.map(opcional => {

            const nombre = opcional.item || '';
            const grupo = opcional.grupo || '';
            const precio = Number(opcional.precio || 0);

            return `➕ ${grupo}: ${nombre} (+${moneda} ${precio})`;

        }).join('\n');

    };

    const handleWhatsappMessage = (data) => {

        const {
            idPedido,
            nombre,
            telefono,
            entrega,
            pago,
            codigo,
            total,
            nota,
            productos,
            pagoRecibir
        } = data;

        const formattedTotalPrice =
            total?.toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const phoneNumber = `${tienda[0]?.telefono}`;

        const productosDetails = productos.map(item => {

            const itemsText = formatItemsForWhatsapp(item.items);

            return `
✅ *${item.titulo}*
      Precio: ${moneda} ${item.precio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} x ${item.cantidad}
      ${itemsText ? `\n${itemsText}` : ''}
`;

        }).join('');

        const message = `
¡Hola! 🌟 Mi pedido es el N°${idPedido}

${productosDetails}

👤 Nombre: ${nombre}

📱 Teléfono: ${telefono}

📦 Entrega: ${entrega}

💵 Forma de pago: ${pago}

📌 Pago al recibirlo: ${pagoRecibir}

🏷 Código de descuento: ${codigo}

✅ Nota: ${nota}

*Total: ${moneda} ${formattedTotalPrice}*
`;

        // URL de WhatsApp
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        // --- Safari Fix ---
        const newWindow = window.open(whatsappUrl, "_blank");

        // Si Safari bloquea la pestaña → abrir en la misma pestaña
        if (!newWindow) {
            window.location.href = whatsappUrl;
        }

        setName('');
        setLocation('');
        setNoteText('');
        setCodigo('');

        setModalIsOpen(false);
        setModalIsOpen2(false);
    };

    const increaseQuantity = (index) => {

        const updatedCartItems = [...cartItems];

        updatedCartItems[index].cantidad += 1;

        setCartItems(updatedCartItems);

        localStorage.setItem(
            'cart',
            JSON.stringify(updatedCartItems)
        );
    };

    const decreaseQuantity = (index) => {

        const updatedCartItems = [...cartItems];

        if (updatedCartItems[index].cantidad > 1) {

            updatedCartItems[index].cantidad -= 1;

            setCartItems(updatedCartItems);

            localStorage.setItem(
                'cart',
                JSON.stringify(updatedCartItems)
            );
        }
    };

    // ---------------- CREAR PEDIDO ----------------
    const [mensaje, setMensaje] = useState('');

    const crearPedido = async () => {

        if (!name.trim()) {
            Swal.fire(
                'Datos incompletos',
                'Es necesario ingresar Apellido y Nombre.',
                'warning'
            );
            return;
        }

        if (!telefono.trim()) {
            Swal.fire(
                'Datos incompletos',
                'Es necesario ingresar el teléfono o WhatsApp.',
                'warning'
            );
            return;
        }

        if (tipoEntrega === 'mesa' && !idMesa) {
            Swal.fire(
                'Datos incompletos',
                'Es necesario seleccionar una mesa.',
                'warning'
            );
            return;
        }

        if (tipoEntrega === 'delivery' && !direccion.trim()) {
            Swal.fire(
                'Datos incompletos',
                'Es necesario ingresar una dirección de entrega.',
                'warning'
            );
            return;
        }

        if (!paymentMethod) {
            Swal.fire(
                'Datos incompletos',
                'Es necesario seleccionar una forma de pago.',
                'warning'
            );
            return;
        }



        const entregaFinal =
            tipoEntrega === 'mesa'
                ? mesas?.find(mes => mes.idMesa == idMesa)?.mesa
                : tipoEntrega === 'recojo'
                    ? 'Recojo en tienda'
                    : direccion;

        setMensaje('Procesando...');

        try {

            const mesaFiltrada = mesas
                ?.filter(mes => mes.idMesa == idMesa)
                ?.map(mesaMap => mesaMap.mesa)[0];

            const productosPedido = cartItems?.map(item => {

                return {
                    idProducto: item?.idProducto,
                    idCategoria: item.idCategoria,
                    titulo: item?.titulo,
                    cantidad: item?.cantidad,
                    items: item?.items,
                    precio: item?.precio,
                    imagen: obtenerImagen(item)
                };
            });
            const productosPedidoJSON =
                JSON.stringify(productosPedido);

            let totalPrice = 0;

            cartItems.forEach(item => {

                const base = Number(item.precio || 0);

                // 🔥 limpiar extras aunque venga "02", "2", "", null, etc
                const extras = Number(String(item.extras || 0).replace(/^0+/, '') || 0);

                const final = (base + extras);

                const subtotal =
                    final * Number(item.cantidad ?? 1);

                totalPrice += subtotal;
            });

            const formData = new FormData();

            formData.append('idMesa', idMesa);

            formData.append(
                'productos',
                productosPedidoJSON
            );

            formData.append('total', totalPrice);

            formData.append('nombre', name);

            formData.append('telefono', telefono);

            formData.append('entrega', entregaFinal);
            formData.append('tipoEntrega', tipoEntrega);
            formData.append('idMesa', tipoEntrega === 'mesa' ? idMesa : '');
            formData.append('direccion', tipoEntrega === 'delivery' ? direccion : '');

            formData.append('pago', paymentMethod);

            formData.append('nota', noteText);

            formData.append('codigo', codigo);

            formData.append('estado', 'Cocina');

            formData.append('pagado', 'No');

            formData.append('pagoRecibir', pagoRecibir);

            formData.append('createdAt', createdAt);


            for (let pair of formData.entries()) {
            }

            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });

            const text = await response.text();

            const data = JSON.parse(text);

            if (data.idPedido) {

                setMensaje('');

                Swal.fire(
                    'Pedido enviado!',
                    `Pedido N°${data.idPedido} creado con éxito.`,
                    'success'
                );

                handleWhatsappMessage(data);

                localStorage.setItem(
                    'idPedido',
                    data.idPedido
                );

                setName('');
                setCodigo('');
                setNoteText('');
                setIdMesa('');

                cargarMesas();

                closeModal();
                closeModal2();

                clearCart();

            } else if (data?.error) {

                setMensaje('');

                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }

        } catch (error) {

            console.error('Error:', error);

            setMensaje('');

            Swal.fire(
                'Error',
                'Error de conexión. Por favor, inténtelo de nuevo.',
                'error'
            );
        }
    };

    useEffect(() => {

        if (metodos && metodos.length > 0) {
            setPaymentMethod(metodos[0].tipo);
        }

    }, [metodos]);

    const handlePaymentChange = (metodo) => {

        setPaymentMethod(metodo);

        if (metodo === 'Transferencia') {
            setPagoRecibir('Si');
        } else {
            setPagoRecibir('');
        }
    };

    const handlePagoRecibirChange = (value) => {
        setPagoRecibir(value);
    };

    return (
        <div>

            <ToastContainer />

            <button
                onClick={openModal}
                className='cartIconFixed'
            >

                {
                    cartItems?.length >= 1 && (
                        <span>{cartItems.length}</span>
                    )
                }

                <FontAwesomeIcon icon={faShoppingCart} />

            </button>

            {/* MODAL PRINCIPAL */}
            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >

                <div className='deFLex'>

                    <button onClick={closeModal}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>

                    <MiPedido />

                </div>

                {
                    estado === 'Abierto' ? (

                        <>

                            {
                                cartItems?.length === 0 ? (

                                    <p className='nohay'>
                                        No hay productos
                                    </p>

                                ) : (

                                    <>

                                        <div className="modal-content-cart">

                                            {
                                                loading ? (

                                                    <p>Cargando...</p>

                                                ) : (

                                                    <div>

                                                        {
                                                            cartItems.map((item, index) => (

                                                                <div
                                                                    key={item?.idProducto}
                                                                    className='cardProductCart'
                                                                >

                                                                    <Anchor
                                                                        to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}
                                                                        onClick={closeModal}
                                                                    >

                                                                        <img
                                                                            src={obtenerImagen(item)}
                                                                            alt="imagen"
                                                                        />

                                                                    </Anchor>

                                                                    <div className='cardProductCartText'>

                                                                        <h3>{item.titulo}</h3>

                                                                        <strong>
                                                                            {moneda}{" "}
                                                                            {Number(
                                                                                item?.precioFinal ??
                                                                                ((Number(item?.precio || 0)) + (Number(item?.extras || 0)))
                                                                            ).toLocaleString("es-ES")}
                                                                        </strong>

                                                                    </div>

                                                                    <div className='deColumn'>

                                                                        <button
                                                                            onClick={() => removeFromCart(item.idProducto)}
                                                                            className='deleteCart'
                                                                        >
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </button>

                                                                        <div className='deFlexCantidad'>

                                                                            <button
                                                                                onClick={() => decreaseQuantity(index)}
                                                                            >
                                                                                -
                                                                            </button>

                                                                            <span>
                                                                                {item.cantidad}
                                                                            </span>

                                                                            <button
                                                                                onClick={() => increaseQuantity(index)}
                                                                            >
                                                                                +
                                                                            </button>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            ))
                                                        }

                                                    </div>

                                                )
                                            }

                                        </div>

                                        <div className='deColumnCart'>

                                            <h4>
                                                Total: {moneda} {totalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                            </h4>

                                            {/* <pre style={{ fontSize: "12px", background: "#111", color: "#0f0", padding: "10px" }}>
                                                {JSON.stringify(cartItems, null, 2)}
                                            </pre> */}

                                            <button
                                                className='btn'
                                                onClick={openModal2}
                                            >
                                                Finalizar pedido
                                            </button>

                                        </div>

                                        {/* MODAL FINALIZAR */}
                                        <Modal
                                            isOpen={modalIsOpen2}
                                            onRequestClose={closeModal2}
                                            className="modal-cart"
                                            overlayClassName="overlay-cart"
                                        >

                                            <div className='deFLex'>

                                                <button onClick={closeModal2}>
                                                    <FontAwesomeIcon icon={faArrowLeft} />
                                                </button>

                                                <h4>(*) Campos obligatorios</h4>

                                            </div>

                                            <div className="modal-send-form">

                                                <input
                                                    type="text"
                                                    id="name"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    placeholder='Apellido y Nombre (*)'
                                                />

                                                <input
                                                    type="number"
                                                    id="telefono"
                                                    value={telefono}
                                                    onChange={(e) => setTelefono(e.target.value)}
                                                    placeholder='Telefono / WhatsApp (*)'
                                                />

                                                <div className='deFLexRadio'>
                                                    <label>Tipo de entrega (*)</label>

                                                    <div className='columnRadio'>
                                                        <input
                                                            type="radio"
                                                            name="tipoEntrega"
                                                            value="mesa"
                                                            checked={tipoEntrega === 'mesa'}
                                                            onChange={() => setTipoEntrega('mesa')}
                                                        />
                                                        <label>Mesa</label>
                                                    </div>

                                                    <div className='columnRadio'>
                                                        <input
                                                            type="radio"
                                                            name="tipoEntrega"
                                                            value="delivery"
                                                            checked={tipoEntrega === 'delivery'}
                                                            onChange={() => setTipoEntrega('delivery')}
                                                        />
                                                        <label>Delivery</label>
                                                    </div>

                                                    <div className='columnRadio'>
                                                        <input
                                                            type="radio"
                                                            name="tipoEntrega"
                                                            value="delivery"
                                                            checked={tipoEntrega === 'recojo'}
                                                            onChange={() => setTipoEntrega('recojo')}
                                                        />
                                                        <label>Recojo en tienda</label>
                                                    </div>
                                                </div>

                                                {/* COMBOBOX MESAS */}
                                                {tipoEntrega === 'mesa' && (
                                                    <div className='mesasGrapCart'>
                                                        <select
                                                            id="idMesa"
                                                            value={idMesa}
                                                            onChange={handleSelectChange}
                                                        >
                                                            <option value="" disabled>
                                                                Selecciona una mesa (*)
                                                            </option>

                                                            {mesas.map((item) => (
                                                                <option
                                                                    key={item.idMesa}
                                                                    value={item.idMesa}
                                                                    disabled={item.estado === 'ocupada'}
                                                                >
                                                                    {item.mesa} {item.estado === 'ocupada' ? '(Ocupada)' : ''}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}

                                                {/* CAMPOS DELIVERY */}
                                                {tipoEntrega === 'delivery' && (
                                                    <div className="direccionContainer">
                                                        <input
                                                            type="text"
                                                            placeholder="Dirección de entrega (*)"
                                                            value={direccion}
                                                            onChange={(e) => setDireccion(e.target.value)}
                                                        />

                                                        <button
                                                            type="button"
                                                            className="btnUbicacion"
                                                            onClick={obtenerUbicacion}
                                                            disabled={buscandoUbicacion}
                                                        >
                                                            📍 {buscandoUbicacion ? 'Obteniendo ubicación...' : 'Usar mi ubicación actual'}
                                                        </button>
                                                    </div>
                                                )}

                                                <div className='deFLexRadio'>

                                                    <label>
                                                        Formas de pago (*)
                                                    </label>

                                                    {
                                                        metodos?.map(metodo => (

                                                            <section
                                                                key={metodo.idMetodo}
                                                                className='columnRadio'
                                                            >

                                                                <div>

                                                                    <input
                                                                        type="radio"
                                                                        name="paymentMethod"
                                                                        id={metodo.tipo}
                                                                        value={metodo.tipo}
                                                                        checked={paymentMethod === metodo.tipo}
                                                                        onChange={() => handlePaymentChange(metodo.tipo)}
                                                                    />

                                                                    <label htmlFor={metodo.tipo}>
                                                                        {metodo.tipo}
                                                                    </label>

                                                                </div>

                                                            </section>

                                                        ))
                                                    }

                                                </div>

                                                <input
                                                    type="text"
                                                    id="codigo"
                                                    value={codigo}
                                                    onChange={(e) => setCodigo(e.target.value)}
                                                    placeholder='Codigo de descuento (opcional)'
                                                />

                                                <textarea
                                                    placeholder="Agrega aquí el horario o cambios del pedido"
                                                    value={noteText}
                                                    onChange={(e) => setNoteText(e.target.value)}
                                                />

                                            </div>

                                            {
                                                mensaje ? (

                                                    <button
                                                        type='button'
                                                        className='btn'
                                                        disabled
                                                    >
                                                        {mensaje}
                                                    </button>

                                                ) : (

                                                    <button
                                                        type='button'
                                                        onClick={crearPedido}
                                                        className='btn'
                                                    >
                                                        Finalizar pedido
                                                    </button>

                                                )
                                            }

                                        </Modal>

                                    </>

                                )
                            }

                        </>

                    ) : (

                        <p className='nohay'>
                            El establecimiento se encuentra
                            <br />
                            cerrado en estos momentos.
                            <br />
                            Consulte por horarios de atención.
                        </p>

                    )
                }

            </Modal>

        </div>
    );
}